import React, {useEffect} from 'react';
import "./footer.css";
// import HatchLogo from "/public/assets/static/HatchInstitute.png";
// import GitLabLogo from "/assets/static/gitlab.png";
// import BunLogo from "/assets/static/Bun.png";
// import ReactLogo from "/assets/static/React.png";

const Footer: React.FC = () => {
	return (
		<footer className='main-footer'>
			<div className="footer-content">
				<div className="footer-logo">
					<img src="/assets/static/hatchdamh.png" alt="Hatch Institute" />
				</div>
				<div className="footer-links">
					<a href="#">Privacy Policy</a>
					<a href="#">Contact</a>
				</div>
				<div className='footer-social'>
					<a href="https://gitlab.com/hatch-institute" target="_blank" rel='noreferrer'>
						<img id="gitlab-icon" src="/assets/static/gitlab.png" alt="gitlab"/>
					</a>
					<a id="attribution" 
						href="https://www.flaticon.com/free-icons/gitlab" 
						target="_blank"
						title='gitlab icons'
					>
					Gitlab Icons created by Freepik - Flaticons
					</a>
					<a id="attribution"
						href="https://pixabay.com/users/joshuaworoniecki-12734309/"
						target='_blank'
						title='Joshua Woroniecki'>
						Video provided by Joshua Woroniecki via Pixabay
					</a>
				</div>
			</div>
			<div className='framework'>
				<img src="/assets/static/Bun.png" alt="" />
				<span>+</span>
				<img src="/assets/static/React.png" alt="" />
			</div>
			<div className='footer-copyright'>
				&copy; 2025 Hatch Data and Mental Health (HatchDAMH). All rights reserved.
			</div>
		</footer>
	)
}

export default Footer;
